import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Card } from 'src/components/Card/Card';
import { Pagination } from 'src/components/Pagination';
import { LoanApplicationDto } from 'src/generated-api-client';
import { LoanApplicationReassignmentReasonsTable } from 'src/pages/LoanApplicationDetailsPage/components/LoanApplicationReassignmentReasonsTable';
import { LoanApplicationReassignmentsStore } from 'src/stores/LoanApplicationReassignmentsStore/LoanApplicationReassignmentsStore';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { Entity } from 'src/utils/mobx/BasicStore/BasicStore.types';

type LoanApplicationReassignmentReasonsTabProps = {
    application?: LoanApplicationDto;
};

const store = LoanApplicationReassignmentsStore;

export const LoanApplicationReassignmentReasonsTab = observer(
    ({ application }: LoanApplicationReassignmentReasonsTabProps) => {
        useEffect(() => {
            if (application?.id) {
                store.filterCriteria.setFilter({ id: application.id });
                store.loadList();
            }

            return () => {
                store.filterCriteria.resetFilter();
                store.pager.reset();
                store.listLoader.reset();
            };
        }, [application?.id]);

        const showEmptyMessage =
            !store.listLoader.isLoading && store.list.length === 0;

        return (
            <>
                <Card title={t('LoanApplication.ReassignmentReasons.Title')}>
                    {showEmptyMessage ? (
                        t(
                            'LoanApplication.ReassignmentReasons.NoReassignmentReasons',
                        )
                    ) : (
                        <LoanApplicationReassignmentReasonsTable />
                    )}
                </Card>
                <Pagination store={store as unknown as BasicStore<Entity>} />
            </>
        );
    },
);
